import type { Thunk } from '~/store';


export const addMockJsHost = (): Thunk => (dispatch, getState) => {
    const state = getState();
    let lastShipLevel: null | number = null;

    const animations: Array<AnimatedLevel> = [];

    const iterateAnimations = () => {
        const animation = animations.shift();
        if (animation) {
            if (window.onClientStateChange) {
                window.onClientStateChange(
                    JSON.stringify({
                        actionId: 'startAnimation',
                        level: animation.level,
                    }),
                );
                setTimeout(() => {
                    window.onClientStateChange(
                        JSON.stringify({
                            actionId: 'finishAnimation',
                            level: animation.level,
                        }),
                    );
                    iterateAnimations();
                }, animation.delay);
            }
        } else {
            setTimeout(() => {
                iterateAnimations();
            }, 500);
        }
    };

    iterateAnimations();

    const fillStack = (delay: number, fromLevel: number, toLevel: number) => {
        if (toLevel > fromLevel) {
            if (delay === 0) {
                animations.push({
                    delay,
                    level: toLevel,
                });
            } else {
                for (let level = fromLevel + 1; level <= toLevel; level++) {
                    animations.push({
                        delay,
                        level,
                    });
                }
            }
        } else {
            animations.push({
                delay,
                level: toLevel,
            });
        }
    };

    if (!state.app.isInGame) {
        setTimeout(() => {
            if (window.onClientStateChange) {
                window.onClientStateChange(
                    JSON.stringify({
                        actionId: 'browserShown',
                    }),
                );
            }
        }, 100);

        window.jsHostQuery = (data: JsHostQueryRequest) => {
            const { timings } = getState().app;
            const req: JsHostQueryReq = JSON.parse(data.request);
            if (req && req.params && req.params.actionId === 'updateDockData' && req.params.info && req.params.info.shipLevel !== undefined) {
                const { shipLevel } = req.params.info;
                if (lastShipLevel !== null && lastShipLevel !== shipLevel) {
                    const fromLevel = lastShipLevel || 0;
                    const timing = timings[fromLevel] ? timings[fromLevel] : 2;
                    const delay = req.params.info.isInstant ? 0 : timing;
                    fillStack(delay, fromLevel, shipLevel);
                }
                lastShipLevel = shipLevel;
            }
        };
    }
};
